module.exports = __webpack_public_path__ + "static/media/bottom-banner-orange.4972b63c.svg";